export default __webpack_public_path__ + "static/media/LifestyleCancellationPageDesktopHeader2.82699e69.jpg";